module.exports = __webpack_public_path__ + "img/44d3469d-f586-425b-a61b-fc2e6bbd8091.63377995.jpg";